import { ChevronDown, LogOut } from "lucide-react";
import { useState } from "react";
import Cookies from "js-cookie";
import { useClickOutside } from "../../utils/useClickOutside";
import { logout } from "../../utils/auth";

function TopBar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useClickOutside(() => setIsDropdownOpen(false));

  const handleLogout = () => {
    logout();
  };

  // Get user info from cookies
  const userName = Cookies.get("userName") || "User";
  const userId = Cookies.get("userId") || "";

  return (
    <header className="h-[56px] sm:h-[60px] bg-[#FBF8F6] border-b border-[#E0DFDB] flex items-center justify-between px-2 sm:px-6 md:px-8 sticky top-0 z-10 w-full">
      {/* Search Bar - Left Side 
      <div className="relative w-32 xs:w-40 sm:w-56 md:w-72 lg:w-96 max-w-full flex-shrink-0 transition-all duration-200">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3 sm:pl-4 pointer-events-none">
          <Search size={18} className="text-gray-900" />
        </span>
        <input
          type="text"
          placeholder="Search product, orders, customers..."
          className="w-full h-8 bg-[#F7F1ED] border border-gray-200 rounded-xl py-2.5 pl-10 pr-3 sm:pr-4 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all"
        />
      </div>*/}
      <h3 className="text-base sm:text-lg font-semibold text-[#0C0C0E] truncate max-w-[120px] xs:max-w-[180px] sm:max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg">
        Welcome {userName}
      </h3>

      {/* Right Side Icons & Profile */}
      <div className="flex items-center gap-2 sm:gap-4 md:gap-6">
        {/* User Profile Section */}
        <div className="relative" ref={dropdownRef}>
          <div
            className="h-8 flex items-center gap-2 sm:gap-3 bg-white border border-gray-100 py-1.5 pl-1.5 pr-3 sm:pr-4 rounded-full cursor-pointer active:scale-95 active:shadow-sm transition-transform duration-100"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <div className="h-5 w-5 rounded-full bg-[#556B2F] flex items-center justify-center text-white font-bold text-xs sm:text-sm">
              {userName.charAt(0).toUpperCase()}
            </div>
            <div className="hidden md:flex items-center gap-1 sm:gap-2">
              <span className="text-xs sm:text-sm font-medium text-[#031731]">
                {userName}
              </span>
              {userId && (
                <span className="text-xs sm:text-sm text-[#8B94A0]">
                  (#{userId})
                </span>
              )}
            </div>
            <ChevronDown
              size={16}
              className={`text-gray-400 bg-[#EDECEA] rounded-full transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`}
            />
          </div>

          {/* Dropdown Modal */}
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-36 sm:w-44 bg-[white] border border-[#E0DFDB] rounded-xl shadow-md overflow-hidden z-50">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 text-xs sm:text-sm font-medium text-[#6B7143] hover:bg-[#F0E6DB] transition-colors active:scale-95 duration-100"
              >
                <LogOut size={16} className="text-red-600" />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default TopBar;
